import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { currentUrl } from "../../../../utils/helper";
import { handleOutlookOAuthReturn } from "./outlookAuthReturnHandler";
import SimpleSpinner from "../../../loader";

// Shared Microsoft (Azure AD) OAuth callback route for BOTH the personal (Messaging > Email) and the
// organization (My Organization > Email) Outlook connections. They share this single redirect_uri —
// the only one registered as authorized in the Azure AD app registration for the app's OAuth client —
// because Microsoft rejects any redirect_uri that isn't pre-registered. The `state` param (echoed back
// unchanged by Microsoft) is how the two flows are told apart; see outlookAuthReturnHandler.ts /
// microsoftOAuth.ts's ORG_OUTLOOK_OAUTH_STATE. Mirrors GmailAuthRetrun.tsx exactly.
const OutlookAuthReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    handleOutlookOAuthReturn(code, state, `${currentUrl}/callback/outlook`).then(navigate);
  }, [location.search, navigate]);

  return (
    <div className="spinnerContainer">
      <SimpleSpinner />
    </div>
  );
};

export default OutlookAuthReturn;
